module.exports = __webpack_public_path__ + "static/media/images-2.f5b54e35.png";